import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TitleCard } from '@/core/components';

import { Publisher } from './../../model/PublisherTypes';
import classes from './PublisherCard.module.css';

export interface PublisherCardProps {
  publisher: Publisher;
  to: string;
}

export function PublisherCard({ publisher, to }: PublisherCardProps) {
  const { title, type, address, peerReview, prestige } = publisher;
  const { t } = useTranslation();

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="10px">
        <TitleCard title={title} />
        <Group>
          <Text
            c="dimmed"
            size="sm"
          >
            {address}
          </Text>
        </Group>
        <Group>
          <Pill>{type?.name}</Pill>
          {prestige === 'YES' && <Pill>{t('publishers.view.prestige')}</Pill>}
          {peerReview === 'YES' && <Pill>{t('publishers.view.peerReview')}</Pill>}
        </Group>
      </Stack>
    </Paper>
  );
}
